import React from 'react';
import TimelineEvent from './TimelineEvent';
import Icon from '../../../components/AppIcon';

const STATUS_LABELS = {
  en_attente: 'En attente',
  depose: 'Envoi déposé / Enlevé chez le client',
  en_preparation: 'Réceptionné à l\'entrepôt',
  en_transit: 'Chargé dans le conteneur / En transit',
  arrive_abidjan: 'Arrivé à Abidjan',
  en_livraison: 'En cours de livraison',
  livre: 'Livré',
  // Legacy English/uppercase variants
  COLLECTED: 'Envoi enlevé chez le client',
  RECEIVED: 'Réceptionné en entrepôt',
  LOADED: 'Chargé dans le conteneur',
  IN_TRANSIT: 'En transit maritime',
  ARRIVED: 'Arrivé à Abidjan',
  DELIVERED: 'Livré',
  PENDING: 'En attente',
  CREATED: 'Envoi créé',
};

const getStatusLabel = (status) => {
  if (!status) return 'Statut inconnu';
  return STATUS_LABELS?.[status] || status;
};

// Order of statuses for progression comparison
const STATUS_ORDER = ['en_attente', 'depose', 'en_preparation', 'en_transit', 'arrive_abidjan', 'en_livraison', 'livre'];

const ShipmentTimeline = ({ shipment, events, currentStatus }) => {
  // Build display events: use passed events if non-empty, otherwise generate from current_status
  let displayEvents = [];

  // Always add "Envoi créé" as first event
  displayEvents?.push({
    status: 'CREATED',
    label: 'Envoi créé',
    timestamp: shipment?.created_at || null,
    message: `Référence : ${shipment?.reference || '—'}`,
  });

  // Add "Envoi déposé" if status is depose or further
  const currentIdx = STATUS_ORDER?.indexOf(currentStatus);
  if (currentIdx >= STATUS_ORDER?.indexOf('depose')) {
    displayEvents?.push({
      status: 'depose',
      label: 'Envoi déposé / Enlevé chez le client',
      timestamp: shipment?.updated_at || shipment?.created_at || null,
      message: null,
    });
  }

  // Add current status event if it's beyond depose and different from depose
  if (currentStatus && currentStatus !== 'CREATED' && currentStatus !== 'depose' && currentIdx > STATUS_ORDER?.indexOf('depose')) {
    displayEvents?.push({
      status: currentStatus,
      label: getStatusLabel(currentStatus),
      timestamp: shipment?.updated_at || shipment?.created_at || null,
      message: null,
    });
  }

  // If only en_attente and no depose yet, show current status
  if (currentStatus && currentStatus !== 'CREATED' && currentIdx < STATUS_ORDER?.indexOf('depose')) {
    displayEvents?.push({
      status: currentStatus,
      label: getStatusLabel(currentStatus),
      timestamp: shipment?.updated_at || shipment?.created_at || null,
      message: null,
    });
  }

  // Append client-visible tracking messages from shipment_messages (container status changes)
  if (events && events?.length > 0) {
    events?.forEach((event) => {
      displayEvents?.push({
        status: 'MESSAGE',
        label: event?.message || 'Mise à jour',
        timestamp: event?.created_at || null,
        message: null,
      });
    });
  }

  const currentStatusIndex = STATUS_ORDER?.indexOf(currentStatus);

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="Clock" size={20} className="text-primary" />
        </div>
        <h2 className="text-xl font-bold text-foreground">Historique de suivi</h2>
      </div>
      <div className="space-y-0">
        {displayEvents?.map((event, index) => {
          const eventStatusIndex = STATUS_ORDER?.indexOf(event?.status);
          const isCompleted = eventStatusIndex >= 0 && eventStatusIndex < currentStatusIndex;
          const isActive = eventStatusIndex === currentStatusIndex || (eventStatusIndex < 0 && index === displayEvents?.length - 1);
          const isLast = index === displayEvents?.length - 1;
          
          return (
            <TimelineEvent
              key={`${event?.status}-${index}`}
              status={event?.status}
              label={event?.label || getStatusLabel(event?.status)}
              timestamp={event?.timestamp}
              message={event?.message}
              isCompleted={isCompleted}
              isActive={isActive}
              isLast={isLast}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ShipmentTimeline;